import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    payrolls: {},
    payroll: {},
    isLoadingTable: false,
    showDeleteModal: false
}

const mutations = {
    getPaginatedPayrolls(state,payload){
        state.isLoadingTable = true
        if(!payload.query){
            payload.query = 'all-data-query'
        }
        let listOfEmployeesUrl = `api/payrolls/page=${payload.page}&pageSize=${payload.pageSize}/${payload.query}`
        if(payload.payrollFrom, payload.payrollTo){
            listOfEmployeesUrl = `${listOfEmployeesUrl}/${payload.payrollFrom}/${payload.payrollTo}`
        }

        axios.get(`${listOfEmployeesUrl}`)
            .then(response => {
                response.data.data.forEach((payroll)=>{
                    payroll.payrollFrom = moment(payroll.payrollFrom).format("MM/DD/YYYY")
                    payroll.payrollTo = moment(payroll.payrollTo).format("MM/DD/YYYY")
                    payroll.payrollDate = moment(payroll.payrollDate).format("MM/DD/YYYY")

                    payroll.netBasic = numeral(payroll.netBasic).format("0,0.00")
                    payroll.totalDeduction = numeral(payroll.totalDeduction).format("0,0.00")
                    payroll.netPay = numeral(payroll.netPay).format("0,0.00")
                })

                state.payrolls = response.data
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(() => {
                state.isLoadingTable = false
            })
    },
    openDeleteModal(state,payload){
        state.showDeleteModal = payload.showDeleteModal
        if(payload.payroll){
            state.payroll = payload.payroll
        }else{
            state.payroll = {}
        }
    }
}

const actions = {
    getPaginatedPayrolls({
        commit
    },payload){
        commit('getPaginatedPayrolls', payload)
    },
    openDeleteModal({commit},payload){
        commit("openDeleteModal",payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}